import React, { useState, useEffect } from "react";
import { API, JS } from "aws-amplify";

import { awsSignIn, authData } from "../../redux/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { Constants } from "../../config/constants";
import config from "../../config/aws-exports";
import { FaBars } from "react-icons/fa";
import { Tab } from "semantic-ui-react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import Skeleton from "@material-ui/lab/Skeleton";
import UserHeader from "../Header/UserHeader/UserHeader";
import { useNavigate, Link } from "react-router-dom";

import i1 from "../../assets/images/i1.jpg";
import i2 from "../../assets/images/i2.jpg";
import i3 from "../../assets/images/i3.png";
import AllProgStyle from "./AllPrograms.module.scss";

const useStyles = makeStyles((theme) => ({
  bodyContent: {
    width: "350px",
    marginTop: "3rem",
    '@media (max-width: 520px)': {
      width: "100%",
    },
  },
  bodyComponent: {
    '& > div > div:first-child': {
      overflowY: "hidden",
    },
  },
}));

function AllPrograms({ handleToggleSidebar }) {
  const classes = useStyles();
  const [ApplicationCate, setApplicationCate] = useState({});
  const [certificateData, setCertificateData] = useState([]);
  const [diplomaData, setDiplomaData] = useState([]);
  const [graduateData, setGraduateData] = useState([]);
  const [pgDiplomaData, setPgDiplomaData] = useState([]);
  const [underGraduateData, setUnderGraduateData] = useState([]);
  const [doctorofPharmacyData, setDoctorofPharmacyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  let navigate = useNavigate();
  const dispatch = useDispatch();
  let userDetails = useSelector(authData);

  useEffect(() => {
    getMyApplicationList();
  }, []);

  async function getMyApplicationList() {
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    setIsLoading(true)
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.ALL_PROGRAM,
        bodyParam
      );
      const ApplicationJSON = response;
      setApplicationCate(ApplicationJSON);
      setCertificateData(ApplicationJSON.certificate);
      setDiplomaData(ApplicationJSON.diploma);
      setGraduateData(ApplicationJSON.graduate);
      setPgDiplomaData(ApplicationJSON.pgdiploma);
      setUnderGraduateData(ApplicationJSON.undergraduate);
      setUnderGraduateData(ApplicationJSON.undergraduate);
      setUnderGraduateData(ApplicationJSON.undergraduate);
      setDoctorofPharmacyData(ApplicationJSON.DoctorofPharmacy);

      console.log("Apply1", ApplicationJSON);

      setIsLoading(false)
    } catch (error) {
      console.error(error);
    }
  }
  /*  console.log("1",certificateData);
   console.log("2",diplomaData);
   console.log("3",graduateData);
   console.log("4",pgDiplomaData);
   console.log("5",underGraduateData); */

  function cardClick(course) {
    let sdata = { ...userDetails };
    sdata.applypid = course.pid;
    sdata.applybpid = course.bpid;

    dispatch(awsSignIn(sdata));

    navigate("/applyProgram");
  }

  const panes = [
    {
      menuItem: "Under Graduate",
      render: () => (
          <Tab.Pane>
            <div style={{ display: "flex", flexWrap: "wrap", }}>
                {underGraduateData.length === 0 ? (
                  <Typography component="list" variant="h1">
                    {isLoading ? <Skeleton  style={{width: "23rem", marginLeft: "1rem", height: "13rem",}} /> : <h2 style={{marginLeft: "10rem"}}>No courses</h2>}
                  </Typography>
              ) : (
                underGraduateData.map((course) => {
                  return (
                    <div className={classes.bodyContent}>
                      <div
                        onClick={() => {
                          cardClick(course);
                        }}
                      >
                        <Card
                          className={AllProgStyle.card}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            style={{
                              backgroundImage: `url('https://${Constants.DOMAIN
                                }/${config.aws_org_id.toLowerCase()}-resources/images/program-images/${course.pid
                                }.png')`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                            }}
                            alt=""
                            className={AllProgStyle.imageCard} /* src={i3} */
                          />
                          <p
                            className={AllProgStyle.topicName}
                            style={{ marginTop: "250px" }}
                          >
                            {" "}
                            <p
                              dangerouslySetInnerHTML={{ __html: course.pname }}
                            ></p>
                          </p>
                        </Card>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </Tab.Pane>
      ),
    },
    {
      menuItem: "Post Graduate",
      render: () => (
        <Tab.Pane>
          <div style={{ display: "flex", flexWrap: "wrap", }}>
            {graduateData.length === 0 ? (
              <Typography component="list" variant="h1">
                {isLoading ? <Skeleton  style={{ width: "23rem", marginLeft: "1rem", height: "13rem", }}/> : <h2 style={{ marginLeft: "10rem" }}>No courses</h2>}
              </Typography> 
            ) : (
              graduateData.map((course) => {
                return (
                  <div className={classes.bodyContent}>
                    <div
                      onClick={() => {
                        cardClick(course);
                      }}
                    >
                      <Card
                        className={AllProgStyle.card}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          style={{
                            backgroundImage: `url('https://${Constants.DOMAIN
                              }/${config.aws_org_id.toLowerCase()}-resources/images/program-images/${course.pid
                              }.png')`,

                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                          }}
                          alt=""
                          className={AllProgStyle.imageCard} /* src={i3} */
                        />
                        <p
                          className={AllProgStyle.topicName}
                          style={{ marginTop: "250px" }}
                        >
                          {" "}
                          <p
                            dangerouslySetInnerHTML={{ __html: course.pname }}
                          ></p>
                        </p>
                      </Card>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </Tab.Pane>
      ),
    },

    {
      menuItem: "Doctor Of Pharmacy",
      render: () => (
        <Tab.Pane>
          <div style={{ display: "flex", flexWrap: "wrap", }}>
            {doctorofPharmacyData.length === 0 ? (
              <Typography component="list" variant="h1">
                {isLoading ? <Skeleton  style={{ width: "23rem", marginLeft: "1rem", height: "13rem", }}/> : <h2 style={{ marginLeft: "10rem" }}>No courses</h2>}
              </Typography> 
            ) : (
              doctorofPharmacyData.map((course) => {
                return (
                  <div className={classes.bodyContent}>
                    <div
                      onClick={() => {
                        cardClick(course);
                      }}
                    >
                      <Card
                        className={AllProgStyle.card}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          style={{
                            backgroundImage: `url('https://${Constants.DOMAIN
                              }/${config.aws_org_id.toLowerCase()}-resources/images/program-images/${course.pid
                              }.png')`,

                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                          }}
                          alt=""
                          className={AllProgStyle.imageCard} /* src={i3} */
                        />
                        <p
                          className={AllProgStyle.topicName}
                          style={{ marginTop: "250px" }}
                        >
                          {" "}
                          <p
                            dangerouslySetInnerHTML={{ __html: course.pname }}
                          ></p>
                        </p>
                      </Card>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </Tab.Pane>
      ),
    },

    // {
    //   menuItem: "Diploma",
    //   render: () => (
    //     <Tab.Pane>
    //       <div className="row">
    //         <div className="row">
    //           {diplomaData.length === 0 ? (
    //             <h2 style={{ marginLeft: "10rem" }}>No courses</h2>
    //           ) : (
    //             diplomaData.map((course) => {
    //               return (
    //                 <div style={{ width: "350px", marginTop: "70px" }}>
    //                   <div
    //                     onClick={() => {
    //                       cardClick(course);
    //                     }}
    //                   >
    //                     <Card className={AllProgStyle.card}>
    //                       <img
    //                         style={{
    //                           backgroundImage: `url('https://${
    //                             Constants.DOMAIN
    //                           }/${config.aws_org_id.toLowerCase()}-resources/images/program-images/${
    //                             course.pid
    //                           }.png')`,
    //                           backgroundSize: "cover",
    //                           backgroundPosition: "center",
    //                           backgroundRepeat: "no-repeat",
    //                         }}
    //                         alt=""
    //                         className={AllProgStyle.imageCard} /* src={i3} */
    //                       />
    //                       <p
    //                         className={AllProgStyle.topicName}
    //                         style={{ marginTop: "250px" }}

    //                       >
    //                         {" "}
    //                         <p  dangerouslySetInnerHTML={{ __html: course.pname }}></p>
    //                       </p>
    //                     </Card>
    //                   </div>
    //                 </div>
    //               );
    //             })
    //           )}
    //         </div>
    //       </div>
    //     </Tab.Pane>
    //   ),
    // },
    // {
    //   menuItem: "Certificate",
    //   render: () => (
    //     <Tab.Pane>
    //       <div className="row">
    //         <div className="row">
    //           {certificateData.length === 0 ? (
    //             <h2 style={{ marginLeft: "10rem" }}>No courses</h2>
    //           ) : (
    //             certificateData.map((course) => {
    //               <div style={{ width: "350px", marginTop: "70px" }}>
    //                 <div
    //                   onClick={() => {
    //                     cardClick(course);
    //                   }}
    //                 >
    //                   <Card className={AllProgStyle.card}>
    //                     <img
    //                       style={{
    //                         backgroundImage: `url('https://${
    //                           Constants.DOMAIN
    //                         }/${config.aws_org_id.toLowerCase()}-resources/images/program-images/${
    //                           course.pid
    //                         }.png')`,
    //                         backgroundSize: "cover",
    //                         backgroundPosition: "center",
    //                         backgroundRepeat: "no-repeat",
    //                       }}
    //                       alt=""
    //                       className={AllProgStyle.imageCard} /* src={i3} */
    //                     />
    //                     <p
    //                       className={AllProgStyle.topicName}
    //                       style={{ marginTop: "250px" }}
    //                     >
    //                       {" "}
    //                       <p  dangerouslySetInnerHTML={{ __html: course.pname }}></p>
    //                     </p>
    //                   </Card>
    //                 </div>
    //               </div>;
    //             })
    //           )}
    //         </div>
    //       </div>
    //     </Tab.Pane>
    //   ),
    // },
    // {
    //   menuItem: "PG Diploma",
    //   render: () => (
    //     <Tab.Pane>
    //       <div className="row">
    //         <div className="row">
    //           {pgDiplomaData.length === 0 ? (
    //             <h2 style={{ marginLeft: "10rem" }}>No courses</h2>
    //           ) : (
    //             pgDiplomaData.map((course) => {
    //               return (
    //                 <div style={{ width: "350px", marginTop: "70px" }}>
    //                   <div
    //                     onClick={() => {
    //                       cardClick(course);
    //                     }}
    //                   >
    //                     <Card className={AllProgStyle.card}>
    //                       <img
    //                         style={{
    //                           backgroundImage: `url('https://${
    //                             Constants.DOMAIN
    //                           }/${config.aws_org_id.toLowerCase()}-resources/images/program-images/${
    //                             course.pid
    //                           }.png')`,
    //                           backgroundSize: "cover",
    //                           backgroundPosition: "center",
    //                           backgroundRepeat: "no-repeat",
    //                         }}
    //                         alt=""
    //                         className={AllProgStyle.imageCard} /* src={i3} */
    //                       />
    //                       <p
    //                         className={AllProgStyle.topicName}
    //                         style={{ marginTop: "250px" }}
    //                       >
    //                         {" "}
    //                         <p  dangerouslySetInnerHTML={{ __html: course.pname }}></p>
    //                       </p>
    //                     </Card>
    //                   </div>
    //                 </div>
    //               );
    //             })
    //           )}
    //         </div>
    //       </div>
    //     </Tab.Pane>
    //   ),
    // },
  ];

  return (
    <main>
      <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
        <FaBars />
      </div>
      <div>
        <UserHeader />
        <div className={classes.bodyComponent}>
          <div>
            <h1 style={{ marginBottom: "2rem" }}>Application</h1>
          </div>
          <Tab panes={panes} />
        </div>
      </div>
    </main>
  );
}

export default AllPrograms;
